import PropTypes from "prop-types";
import React from "react";
//import icons from "../../../assets/icon-sprite.svg";

const Icon = ({ id, height, width, className = "", ...props }) => (
  <svg width={width} height={height} {...props} className={`flex-shrink-0 ${className}`}>
   <use
      xlinkHref={`${process.env.PUBLIC_URL}/assets/svgs/icon-sprite.svg#${id}`}
    />
  </svg>
);

Icon.propTypes = {
  id: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string
  // type: PropTypes.oneOf(['text', 'password', 'number', 'tel']).isRequired,
  // size: PropTypes.oneOf(['small', 'medium', 'large']),
  // onChange: PropTypes.func,
  // onKeyDown: PropTypes.func,
};

Icon.defaultProps = {
  height: "40px",
  width: "40px"
};

export default Icon;
